import { emitToast, downloadBusProps } from './emitToast'

/**
 * Trigger download of a CSV string (from text) or a Blob,
 * inferring filename from the Content-Disposition header.
 */
export async function handleCsvDownload(data: string | Blob, contentDisposition: string | null) {
  if (typeof document === 'undefined') {
    return
  }

  // Normalize to Blob
  const blob = data instanceof Blob ? data : new Blob([data], { type: 'text/csv' })

  // Create object URL
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url

  // Extract filename from headers (fallback to .csv)
  const cd = contentDisposition || ''
  let filename = 'download.csv'

  // RFC 5987 style filename*=UTF-8''
  const starMatch = /filename\*=UTF-8''([^;]+)/i.exec(cd)
  if (starMatch?.[1]) {
    try {
      filename = decodeURIComponent(starMatch[1])
    } catch {
      /* ignore decode errors and fallback */
    }
  } else {
    // regular filename="..."
    const quoteMatch = /filename="([^"]+)"/i.exec(cd)
    if (quoteMatch?.[1]) {
      filename = quoteMatch[1]
    }
  }

  a.download = filename

  // Download
  document.body.appendChild(a)
  a.click()

  // Cleaning
  requestAnimationFrame(() => {
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
    emitToast({
      message: 'CSV downloaded.',
      ...downloadBusProps,
    })
  })
}
